import ShopAddons from '@app/views/ShopAddons';
import GroupedAddon from '@app/views/ShopAddons/containers/GroupedAddon';
import SingleAddon from '@app/views/ShopAddons/containers/SingleAddon';

import { NestedRoutes, RouteRenderProps } from '../utils';
import { ShopAddonsLink } from '../constants';

/*
 *
 * I followed the example of
 *   apps/mv-web/src/Navigator/NestedSwitch/PlanSwitch.tsx
 * to make the routing work :(
 *
 * Why is our routing so complicated?
 */
export const shopAddonsRoutes: RouteRenderProps[] = [
  {
    path: ShopAddonsLink.ShopAddons,
    render: <ShopAddons />,
    exact: true,
    fromParent: 0,
  },
  {
    path: ShopAddonsLink.SingleAddon,
    render: <SingleAddon />,
    exact: true,
    fromParent: 0,
  },
  {
    path: ShopAddonsLink.GroupedAddon,
    render: <GroupedAddon />,
    exact: true,
    fromParent: 0,
  },
];

export const ShopAddonsSwitch = (): JSX.Element => {
  return <NestedRoutes routes={shopAddonsRoutes} />;
};
